
<header class="admin-navbar" *ngIf="usernav === 'Admin'">
  <nav class="navbar-container">
    <!-- Brand -->
    <a routerLink="/admin-hotel" class="mobile-category">
      <div class="navbar-brand">
        <div class="brand-icon">
          <mat-icon>apartment</mat-icon>
        </div>
        <div class="brand-text">
          <h1>Turismo Rural Colombia</h1>
          <span>Panel de Administración</span>
        </div>
      </div>
    </a>

    <!-- Links (desktop) -->
    <ul class="navbar-links">
      <li><a routerLink="/admin-hotel-hostings"
          routerLinkActive="active-link"><mat-icon>apartment</mat-icon>Alojamientos</a></li>
      <li><a routerLink="/admin-hotel-reservations"
          routerLinkActive="active-link"><mat-icon>calendar_today</mat-icon>Reservas</a></li>
      <li><a routerLink="/create-recepcionist"
          routerLinkActive="active-link"><mat-icon>group</mat-icon>Recepcionista</a></li>
      <li><a routerLink="/admin-hotel/inventario"
          routerLinkActive="active-link"><mat-icon>inventory</mat-icon>Inventario</a></li>
    </ul>

    <!-- Avatar -->
    <div class="navbar-user">
      <button class="avatar-circle" matIconButton [matMenuTriggerFor]="menu"
        aria-label="Example icon-button with a menu">
        <mat-icon>account_circle</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="signOut()">
          <mat-icon>logout</mat-icon>
          <span>Cerrar sesión</span>
        </button>
      </mat-menu>
    </div>

    <!-- Mobile menu toggle -->
    <button class="menu-toggle" mat-icon-button (click)="toggleMenu()">
      <mat-icon>{{ mobileMenuOpen ? 'close' : 'menu' }}</mat-icon>
    </button>
  </nav>

  <!-- Mobile menu -->
  <div class="mobile-menu" *ngIf="mobileMenuOpen">
    <a routerLink="/admin-hotel-reservations"
      routerLinkActive="active-link"><mat-icon>apartment</mat-icon>Alojamientos</a>
    <a routerLink="/admin-hotel-reservations"
      routerLinkActive="active-link"><mat-icon>calendar_today</mat-icon>Reservas</a>
    <a routerLink="/create-recepcionist" routerLinkActive="active-link"><mat-icon>group</mat-icon>Recepcionista</a>
    <a routerLink="/admin-hotel/inventario" routerLinkActive="active-link"><mat-icon>inventory</mat-icon>Inventario</a>
  </div>
</header>

<header class="admin-navbar" *ngIf="usernav === 'Recepcion'">
  <nav class="navbar-container">

    <!-- Brand -->
    <a routerLink="/admin-recepcion-page" class="mobile-category">
      <div class="navbar-brand">
        <div class="brand-icon">
          <mat-icon>home</mat-icon>
        </div>
        <div class="brand-text">
          <h1>Eco-Turismo</h1>
          <span>Panel Recepción</span>
        </div>
      </div>
    </a>

    <!-- Desktop Links -->
    <ul class="navbar-links">
      <li>
        <a routerLink="/admin-recepcion-page" routerLinkActive="active-link">
          <mat-icon>home</mat-icon>Inicio
        </a>
      </li>

      

      <li>
        <a routerLink="/my-reservations" routerLinkActive="active-link">
          <mat-icon>event_note</mat-icon>Administrar reservas
        </a>
      </li>

      <li><a routerLink="/admin-hotel/inventario"
          routerLinkActive="active-link"><mat-icon>inventory</mat-icon>Inventario</a>
        </li>
    </ul>

    <!-- Avatar -->
    <div class="navbar-user">
      <button class="avatar-circle" matIconButton [matMenuTriggerFor]="menu"
        aria-label="User menu">
        <mat-icon>account_circle</mat-icon>
      </button>

      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="signOut()">
          <mat-icon>logout</mat-icon>
          <span>Cerrar sesión</span>
        </button>
      </mat-menu>
    </div>

    <!-- Mobile Toggle -->
    <button class="menu-toggle" mat-icon-button (click)="toggleMenu()">
      <mat-icon>{{ mobileMenuOpen ? 'close' : 'menu' }}</mat-icon>
    </button>
  </nav>

  <!-- Mobile Menu -->
  <div class="mobile-menu" *ngIf="mobileMenuOpen">
    <a routerLink="/admin-recepcion-page" routerLinkActive="active-link">
      <mat-icon>home</mat-icon>Inicio
    </a>

    <a routerLink="/admin-recepcion" routerLinkActive="active-link">
      <mat-icon>meeting_room</mat-icon>Recibir huéspedes
    </a>

    <a routerLink="/estadias" routerLinkActive="active-link">
      <mat-icon>calendar_today</mat-icon>Estadías
    </a>

    <a routerLink="/my-reservations" routerLinkActive="active-link">
      <mat-icon>event_note</mat-icon>Administrar reservas
    </a>
  </div>
</header>


<header class="admin-navbar" *ngIf="!usernav">
  <nav class="navbar-container">

    <!-- Brand -->
    <a routerLink="/" class="mobile-category">
      <div class="navbar-brand">
        <div class="brand-icon">
          <mat-icon>explore</mat-icon>
        </div>
        <div class="brand-text">
          <h1>Eco-Turismo</h1>
        </div>
      </div>
    </a>


    <!-- Login Button -->
    <div class="navbar-user">
      <button mat-flat-button color="primary" routerLink="/loggin">
        <mat-icon>login</mat-icon> Iniciar sesión
      </button>
    </div>

    <!-- Mobile menu toggle -->
    <button class="menu-toggle" mat-icon-button (click)="toggleMenu()">
      <mat-icon>{{ mobileMenuOpen ? 'close' : 'menu' }}</mat-icon>
    </button>
  </nav>

  <!-- Mobile menu -->
  <div class="mobile-menu" *ngIf="mobileMenuOpen">
    <a routerLink="/" routerLinkActive="active-link">
      <mat-icon>home</mat-icon>Inicio
    </a>

    <a routerLink="/hostinglist" routerLinkActive="active-link">
      <mat-icon>hotel</mat-icon>Alojamientos
    </a>

    <a routerLink="/experiencias" routerLinkActive="active-link">
      <mat-icon>hiking</mat-icon>Experiencias
    </a>

    <a routerLink="/contacto" routerLinkActive="active-link">
      <mat-icon>call</mat-icon>Contacto
    </a>

    <button class="mobile-login-btn" mat-button routerLink="/loggin">
      <mat-icon>login</mat-icon> Iniciar sesión
    </button>
  </div>
</header>
